module.exports = __webpack_public_path__ + "static/media/1.6b03ee2c.svg";